module.exports = __webpack_public_path__ + "img/icon_waku_reset.c7af46e6.png";